/* eslint-disable import/no-cycle */
import { Accordion } from 'crux';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import get from 'lodash/get';
import GetElementFunc from '../../util/GetElement';
import { insertReflexiveQuestions, scrollQuestionIntoView } from '../../utils';

const AccordionWrapper = styled.div`
  width: 100%;
  max-width: 650px;
  @media (max-width: 768px) {
    max-width: 600px;
  }
  @media (max-width: 480px) {
    max-width: 350px;
  }
  margin: 15px 0 25px;
`;

const isRequired = (question) => {
  return get(question, 'validations.required.value', false);
};

const AccordionQuestions = ({ sectionIndex, originalQuestions, questionObj, theme }) => {
  const { pageId } = theme;
  const pageOverrides = get(theme, 'config.theme.pageOverrides', {});
  const accordionIcon = get(pageOverrides, [pageId, 'icons', questionObj.question_id], { src: '' });
  const { src: iconSrc, theme: iconTheme } = accordionIcon;
  const themeConfiguration = get(pageOverrides, [pageId, 'accordionTheme'], {});

  const reflexiveListQ = insertReflexiveQuestions(originalQuestions);
  const handleFocus = (e) => {
    scrollQuestionIntoView({
      element: e.target,
      theme,
    });
  };

  return (
    <AccordionWrapper name='accordion-wrapper' onFocus={ handleFocus }>
      <Accordion
        title={ questionObj.question_text }
        iconSrc={ iconSrc }
        iconTheme={ iconTheme }
        defaultOpened={ questionObj.expand }
        themeConfiguration={ themeConfiguration }
        isIconAriaHidden
      >
        {reflexiveListQ.map((q) => (
          <GetElementFunc questionObj={ q } sectionIndex={ sectionIndex } required={ isRequired(q) } />
        ))}
      </Accordion>
    </AccordionWrapper>
  );
};

export default withTheme(AccordionQuestions);
